import { render, staticRenderFns } from "./modal-assign-transporter.vue?vue&type=template&id=02d369a6"
import script from "./modal-assign-transporter.vue?vue&type=script&lang=js"
export * from "./modal-assign-transporter.vue?vue&type=script&lang=js"
import style0 from "./modal-assign-transporter.vue?vue&type=style&index=0&id=02d369a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports